import {
    // faStore,
    // faLayerGroup,
    faUserShield,
} from '@fortawesome/free-solid-svg-icons';


export const productList = [
    {
        key: 'art-live',
        applicationCode: 'LIVE_CONNECT',
        to: '/live/dashboard',
        prefix: 'live',
        imgSrc: '/assets/images/logo-art-live.png',
        // icon: faBolt, // replaced by the product logo below
        logo: '/assets/images/live-connect-short.svg',
        accent: '#04adc3',
        accentAlt: '#038b9e',
        motif: 'signal',
        title: 'Live Connect',
        tagline: 'Realtime message flow',
        description: 'Manage the Flash speed with Flexible control over the message flow',
        stages: [
            'Opening realtime channels',
            'Syncing live message streams',
            'Calibrating your interceptors',
        ],
        readyLabel: "You're live",
    },
    {
        key: 'art-agent',
        applicationCode: 'AGENT_LAB',
        to: '/agent-builder/dashboard',
        prefix: 'agent-builder',
        imgSrc: '/assets/images/logo-art-agent-builder.png',
        // icon: faRobot, // replaced by the product logo below
        logo: '/assets/images/agent-lab-short.svg',
        accent: '#008cff',
        accentAlt: '#006fcc',
        motif: 'graph',
        title: 'Agent Lab',
        tagline: 'Build & deploy no-code agents',
        description: 'A No code agent lab. Now build and deploy your own agents without writing a single line of code',
        stages: [
            'Warming up the lab',
            'Loading agent blueprints & skills',
            'Wiring your no-code canvas',
        ],
        readyLabel: 'The lab is ready',
    },
    {
        key: 'art-datalake',
        applicationCode: 'DATALAKE',
        to: '/datalake/overview',
        prefix: 'datalake',
        imgSrc: '/assets/images/datalake.svg?v=cosmic-memory',
        logo: '/assets/images/datalake-short.svg?v=cosmic-memory',
        accent: '#10b981',
        accentAlt: '#047857',
        motif: 'grid',
        title: 'Datalake',
        tagline: 'Persistent data for agents',
        description: 'Manage typed application data, relationships, triggers and agent memory with ART-native isolation',
        stages: ['Connecting your data plane','Loading scoped tables','Preparing agent memory'],
        readyLabel: 'Your data is ready',
    },
    // {
    //     key: 'art-app-studio',
    //     applicationCode: 'INTERFACE',
    //     to: '/app-studio/dashboard',
    //     prefix: 'app-studio',
    //     icon: faLayerGroup,
    //     accent: '#7c3aed',
    //     accentAlt: '#5b21b6',
    //     motif: 'grid',
    //     title: 'App Studio',
    //     tagline: 'Compose & ship apps',
    //     description: 'Design, configure and publish your applications from a single studio',
    //     stages: [
    //         'Opening the studio',
    //         'Loading your app catalogue',
    //         'Preparing the canvas',
    //     ],
    //     readyLabel: 'Studio is ready',
    // },
    // {
    //     // Repurposed for Cookbook Recipe Marketplace v2 — points straight at
    //     // /marketplace/cookbook (the client browse/instantiate flow in
    //     // global/marketplace-v2/), not the older, still-unreleased generic
    //     // /marketplace app this tile originally pointed to.
    //     key: 'art-marketplace',
    //     applicationCode: 'MARKETPLACE',
    //     to: '/marketplace/cookbook',
    //     prefix: 'marketplace',
    //     imgSrc: '/assets/images/logo-art-marketplace.png',
    //     icon: faStore,
    //     accent: '#f5a524',
    //     accentAlt: '#f97316',
    //     motif: 'grid',
    //     title: 'Marketplace',
    //     tagline: 'Ready-made agent recipes',
    //     description: 'Browse ready-made agent + orchestrator recipes and add them to your organization in a few clicks',
    //     stages: [
    //         'Opening the marketplace',
    //         'Fetching listed recipes',
    //         'Checking your entitlements',
    //     ],
    //     readyLabel: 'Recipes ready',
    // },
    {
        key: 'art-super-admin',
        to: '/super-admin/dashboard',
        prefix: 'super-admin',
        imgSrc: '/assets/images/logo_art_marketplace.svg',
        icon: faUserShield,
        accent: '#7d96b3',
        accentAlt: '#475569',
        motif: 'shield',
        title: 'Super Admin',
        tagline: 'Tenant & platform control',
        description: 'Super admin',
        role: 'SuperAdmin',
        stages: [
            'Verifying elevated access',
            'Loading the tenant registry',
            'Applying platform policies',
        ],
        readyLabel: 'Control granted',
    },
];

export const generalMenuItems = [
    {
        title: 'Account Settings',
        to: '/account-settings/general/personal-profile',
        dataQa: 'drop-menu-personal-settings',
    },
    {
        title: 'Account Security',
        to: '/account-settings/general/accounts',
        dataQa: 'drop-menu-account-security',
    },
    {
        title: 'App Management',
        to: '/application-settings/general',
        dataQa: 'drop-menu-app-settings',
    },
    {
        title: 'Client Credentials',
        to: '/platform-settings/client',
        dataQa: 'drop-menu-client-credentials',
    },
    {
        title: 'Add Worksapce',
        to: '#',
        dataQa: 'drop-menu-workspace',
    },
];
